import React, { useState } from 'react';
import { FaTaxi, FaBars, FaTimes, FaPhoneAlt, FaUser, FaSearch } from 'react-icons/fa';
import './nav.css';





function NavComp() {
  const [isOpen, setIsOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);


  return (
    <nav className="navbar">
      {/* Top Bar */}
      <div className="top-bar">
        <div className="container">
          
        <div className="contact-info">
       
          <a href="tel:0777439610" className="phone-link">   <FaPhoneAlt className="icon" /> 077 743 9610</a> 
          </div>

        </div>
      </div>

      {/* Main Navigation */}
      <div className="main-nav">
        <div className="container">
          {/* Logo */}
            <div className="logo">
        <img src="/nav logo.png" alt="Southern Rehab Care Logo" className="logo-img" />
        </div>

          {/* Desktop Navigation */}
        <ul className={`nav-links ${isOpen ? 'active' : ''}`}>
  <li><a href="/">Home</a></li>

  <li className="dropdown">
    <a href="#">Products ▼</a>

    <ul className="dropdown-menu">
      <li>
        <a href="/upper-extremity-prosthetics">
          Upper Extremity Prosthetics & Orthotics
        </a>
      </li>

      <li>
        <a href="/lower-extremity-prosthetics">
          Lower Extremity Prosthetics & Orthotics
        </a>
      </li>


      <li>
        <a href="/spinal-orthotics">
          Spinal Othotics
        </a>
      </li>

 

      <li>
        <a href="/reha-mobility">
          Reha Mobility Solutions
        </a>
      </li>

      <li>
        <a href="/orthopedics-children">
          Orthopedics for Children
        </a>
      </li>
    </ul>
  </li>
           <li>
        <a href="/physiotherapy-for-rehabilitation">
          Physiotherapy For Rehabilitation 
        </a>
      </li>
      
  <li><a href="/aboutus">About</a></li>
  <li><a href="/contactus">Contact</a></li>
</ul>

          {/* Mobile Navigation Toggle */}
          <div className="mobile-toggle" onClick={toggleMenu}>
            {isOpen ? <FaTimes /> : <FaBars />}
          </div>



        </div>

      </div>
    </nav>
  );
}

export default NavComp;